export const BUILD_TIMESTAMP = '2025-06-11T10:53:10.496Z';
